import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { colors } from "theme";
import Lines from "components/common/Svg/Lines";

import {
  Text,
  DrawerContext,
  BreakpointContext,
  LayoutContext,
  ReferralLinkButton,
  withQuery,
} from "components/common";
import BellIcon from "components/common/Svg/Bell";
import { hasPagePermission } from "routes/utils";
import { HEADER_QUERY } from "utils/mutations";
import { TOMO_IQ, NOTIFICATIONS, TOMO_BOOST } from "routes/pageConfig";
import { NAVBAR_BACKGROUND } from "components/Navbar/consts";
import Boop from "../common/Boop";
import HeaderDropdown from "./HeaderDropdown";

const HEADER_COLORS = {
  default: {
    background: 'bg-off-white',
    text: 'text-black',
    iconColor: colors["black-primary"],
    border: "#EFF4F3",
  },
  boost: {
    background: 'bg-off-white',
    text: 'text-black',
    iconColor: colors["black-primary"],
    border: "#EFF4F3",
  },
};

const DARK_THEME_PATHS = [TOMO_IQ.path, TOMO_BOOST.path];

const HeaderDesktop = ({ data: { simpleUser: user } }) => {
  const { openDrawer } = useContext(DrawerContext);
  const { isBelow } = useContext(BreakpointContext);
  const { toggleForceCollapse } = useContext(LayoutContext);
  const { push } = useHistory();
  // const { showBanner, hideBanner } = useBanner();

  const location = useLocation();
  const path = location.pathname;

  let headerColors = HEADER_COLORS.default;
  if (DARK_THEME_PATHS.some((darkPath) => path.startsWith(darkPath))) {
    headerColors = HEADER_COLORS.boost;
  }

  const { roles } = useSelector((state) => state.user);

  return (
    <div className="flex-col">
      <div
        className={`flex ${headerColors.background} py-4 px-4 h-full items-center justify-between navbar-transition`}
        style={{ borderBottom: `1px solid ${headerColors.border}` }}
      >
        <button
          type="button"
          onClick={(e) =>
            (isBelow("xl")
              ? openDrawer(
                e,
                "NavbarMenu",
                {
                  anchor: "left",
                  width: "240px",
                  background: NAVBAR_BACKGROUND,
                },
                { showCloseButton: false },
              )
              : toggleForceCollapse())
          }
          className="outline-0-important"
        >
          <Lines color={headerColors.iconColor} style={{ width:26 }} />
        </button>
        <div className={`flex items-center xl:w-full xl:justify-end ${headerColors.text}`}>
          {user.first_name ? (
            <Text className="font-bold px-4">{`Hi, ${user.first_name}!`}</Text>
          ) : (
            <></>
          )}
          {(roles.ambassador && !roles.user_terminated_with_balance) && (
            <>
              <Text className="hidden md:inline-block">Boost your cash back up to 20%</Text>
              <ReferralLinkButton user={user} className="ml-2">
                Refer a friend
              </ReferralLinkButton>
            </>
          )}
          <nav id="navigation">
            <ul className="links mr-3 md:mr-6">
              {(hasPagePermission(NOTIFICATIONS)) && (
                <li>
                  <button
                    type="button"
                    onClick={() => {
                      push("/notifications");
                    }}
                    className="md:ml-12 mx-5 outline-0-important"
                  >
                    <Boop rotation={20} timing={200}>
                      <BellIcon color={headerColors.iconColor} style={{ width: "29px" }} />
                    </Boop>
                  </button>
                </li>
              )}
              <HeaderDropdown className="mr-3" iconColor={headerColors.iconColor}/>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default withQuery(HEADER_QUERY)(HeaderDesktop);
